/* ==========================================================================
   Ure po meri — bag upsell shown after a watch is added to the cart.

   DESIGN NOTE — read this before changing it.
   The first version patched m-cart-drawer.prototype.open to hold the drawer shut
   until the customer answered. That was fragile and twice left the cart looking
   dead: a raised flag also swallowed a click on the cart icon, and any throw in
   the upsell meant nothing opened at all.

   This version never touches the theme. The drawer opens exactly as it always
   did; the upsell is a full-screen layer that covers it, so the customer still
   sees the upsell first and reaches the cart only after answering. If anything
   in here fails, the worst case is no upsell — the cart keeps working.
   ========================================================================== */
(function () {
  'use strict';

  var SKIP_KEY = 'upm-upsell-skipped';
  var root = null, data = null, pendingWatch = false;
  var state = { kind: 'plain', color: null, size: null };   // one version of the bag

  try {
    if (/[?&]upsell=reset/.test(location.search)) sessionStorage.removeItem(SKIP_KEY);
  } catch (err) { /* private mode */ }

  // Two honest reasons to stay away: the cart already holds a bag, or the
  // customer said no in this session.
  function suppressed() {
    if (!root) return true;
    if (root.hasAttribute('data-upm-hasbag')) return true;
    try { return !!sessionStorage.getItem(SKIP_KEY); } catch (err) { return false; }
  }

  // Strings printed by snippets/upm-i18n.liquid, in the language of the page.
  // The fallbacks are Slovene only so a missing snippet degrades to what this
  // file used to say rather than to blank buttons.
  var T = window.UPM_T || {};
  function tx(k, d) { return T[k] || d; }

  // "Velikost: Za 2 uri — ustreza 2 uram v košarici". Liquid picked the plural
  // form for each count it can ever see (the tiers offer 1, 2 or 4), leaving
  // %SIZE% for the size itself.
  function capLine(size, qty) {
    if (!size) return '';
    var s = (qty > 1 && T.capFits && T.capFits[String(qty)]) || tx('cap', 'Velikost: %SIZE%');
    return s.replace('%SIZE%', size);
  }

  // The bag's colour names come back translated ("Črna" reads "Black" on
  // /en-en/), so a hex map keyed by the Slovene word resolved to nothing but
  // grey outside Slovene. Liquid therefore sends the hex on the variant row
  // itself; the name map stays as a fallback for a cached older payload.
  function swatchHex(name) {
    if (data && data.variants) {
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].color === name && data.variants[i].hex) return data.variants[i].hex;
      }
    }
    return (data && data.swatch && data.swatch[name]) || '#888';
  }

  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function uniq(list) { return list.filter(function (v, i) { return list.indexOf(v) === i; }); }

  // The roll costs less next to a watch. The cut itself is an automatic
  // discount in admin; Liquid passes its percentage (data.deal) only so the
  // price shown here is the price Shopify will charge. 0 or missing means no
  // deal, and then nothing below mentions one.
  function dealPct() { return (data && Number(data.deal)) || 0; }
  function dealPrice(cents) { return cents - Math.round(cents * dealPct() / 100); }
  function priceHtml(cents, plus) {
    var p = plus ? '+' : '';
    if (!dealPct()) return p + money(cents);
    return '<s class="upm-was">' + money(cents) + '</s> ' + p + money(dealPrice(cents));
  }
  // "−20 % ob uri  59,90 €  47,92 €" plus one line on what that saves. Built
  // from text nodes: the strings come from the translation files.
  function paintDeal(el, v) {
    if (!el) return;
    if (!v || !dealPct()) { el.hidden = true; return; }
    el.textContent = '';
    var tag = document.createElement('span');
    tag.className = 'upm-deal__tag';
    tag.textContent = tx('dealTag', '−%PCT% % ob nakupu ure').replace('%PCT%', dealPct());
    var was = document.createElement('s');
    was.className = 'upm-was';
    was.textContent = money(v.price);
    var now = document.createElement('strong');
    now.className = 'upm-deal__now';
    now.textContent = money(dealPrice(v.price));
    var save = document.createElement('span');
    save.className = 'upm-deal__save';
    save.textContent = tx('dealSave', 'Prihraniš %SAVE% — sam zvitek stane %FULL%.')
      .replace('%SAVE%', money(v.price - dealPrice(v.price)))
      .replace('%FULL%', money(v.price));
    el.appendChild(tag);
    el.appendChild(was);
    el.appendChild(now);
    el.appendChild(save);
    el.hidden = false;
  }

  function find(kind, color, size) {
    if (!data) return null;
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (v.kind === kind && v.color === color && v.size === size) return v;
    }
    return null;
  }
  function cheapest(kind, size) {
    var best = null;
    (data ? data.variants : []).forEach(function (v) {
      if (v.kind === kind && v.size === size && (!best || v.price < best.price)) best = v;
    });
    return best;
  }

  // ------------------------------------------------------------------ build
  function init() {
    root = document.querySelector('[data-upm-upsell]');
    if (!root || root.__upmInit) return;
    try { data = JSON.parse(root.querySelector('[data-upm-bags]').textContent); } catch (err) { data = null; }
    if (!data || !data.variants || !data.variants.length) return;
    root.__upmInit = true;

    var sizes = uniq(data.variants.map(function (v) { return v.size; }));
    var colors = uniq(data.variants.map(function (v) { return v.color; }));
    state.size = sizes[0];
    state.color = colors[0];

    var sbox = root.querySelector('[data-upm-sizes]');
    if (sbox) {
      sbox.innerHTML = sizes.map(function (s) {
        return '<button type="button" class="upm-size' + (s === state.size ? ' is-active' : '') +
          '" data-size="' + s + '">' + s.replace(/^[^0-9]+/, '') + '</button>';
      }).join('');
      sbox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-size]');
        if (!b) return;
        state.size = b.dataset.size;
        sbox.querySelectorAll('.upm-size').forEach(function (x) { x.classList.toggle('is-active', x.dataset.size === state.size); });
        paint();
      });
    }

    var cbox = root.querySelector('[data-upm-colors]');
    if (cbox) {
      cbox.innerHTML = colors.map(function (c) {
        return '<button type="button" class="upm-swatch' + (c === state.color ? ' is-active' : '') +
          '" data-color="' + c + '" title="' + c + '" aria-label="' + c + '" style="background:' +
          swatchHex(c) + '"></button>';
      }).join('');
      cbox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-color]');
        if (!b) return;
        state.color = b.dataset.color;
        cbox.querySelectorAll('.upm-swatch').forEach(function (x) { x.classList.toggle('is-active', x.dataset.color === state.color); });
        paint();
      });
    }

    root.querySelectorAll('[data-upm-dismiss], [data-upm-skip]').forEach(function (b) {
      b.addEventListener('click', function () { finish(false); });
    });
    var addBtn = root.querySelector('[data-upm-add]');
    if (addBtn) addBtn.addEventListener('click', addBag);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root && !root.hidden) finish(false);
    });
    paint();
  }

  function paint() {
    if (!root || !data) return;
    var v = find(state.kind, state.color, state.size);
    var btn = root.querySelector('[data-upm-add]');
    var label = root.querySelector('[data-upm-add-label]');
    if (btn) btn.disabled = !v;
    if (label) label.textContent = v
      ? tx('add', 'Dodaj zvitek') + ' · ' + money(dealPrice(v.price))
      : tx('unavailable', 'Ta kombinacija ni na voljo');
    paintDeal(root.querySelector('[data-upm-deal]'), v);

    var img = root.querySelector('[data-upm-bagimg]');
    if (img) {
      var src = (v && v.img) || (cheapest('plain', state.size) || {}).img || '';
      if (src && img.getAttribute('src') !== src) img.src = src;
      var hero = img.closest('.upm-upsell__hero');
      if (hero) hero.hidden = !src;
    }
  }

  // ------------------------------------------------------------- open/close
  function show(item) {
    init();
    if (!root || !data || suppressed()) return;

    var img = root.querySelector('[data-upm-thumb]');
    var src = item && ((item.featured_image && item.featured_image.url) || item.image);
    if (img && src) {
      img.src = String(src).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
      img.alt = (item && item.product_title) || '';
    }
    var nameEl = root.querySelector('[data-upm-name]');
    if (nameEl) nameEl.textContent = (item && (item.product_title || item.title)) || tx('fallbackName', 'Tvoja ura');

    // "build one more" opens the same personalizer, empty; "_Koda" marks a built watch
    var more = root.querySelector('[data-upm-another]');
    if (more && item && item.url && item.properties && item.properties._Koda) {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var path = String(item.url).split('?')[0];
      more.href = path.indexOf(base) === 0 ? path : base + path.replace(/^\//, '');
    }

    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    var first = root.querySelector('[data-upm-add]');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }

  function hide() {
    if (!root) return;
    root.classList.remove('is-open');
    setTimeout(function () {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
    }, 220);
  }

  function finish(added) {
    try {
      if (added) { if (root) root.setAttribute('data-upm-hasbag', ''); }
      else { sessionStorage.setItem(SKIP_KEY, '1'); }
    } catch (err) { /* private mode */ }
    hide();
  }

  // The drawer is already open behind the overlay, so it has to be redrawn with
  // the bag in it. A failure here only leaves the drawer momentarily stale — the
  // cart itself is already correct on the server.
  var DEBUG = /[?&]upmdebug=1/.test(location.search);
  function log() { if (DEBUG) console.log.apply(console, ['[upm]'].concat([].slice.call(arguments))); }

  function redrawDrawer() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var want = 'cart-drawer,cart-count' + (document.querySelector('#MinimogCart') ? ',cart-template' : '');
    return fetch(base + '?sections=' + want)
      .then(function (r) { return r.json(); })
      .then(function (payload) {
        if (payload['cart-drawer']) {
          var doc = new DOMParser().parseFromString(payload['cart-drawer'], 'text/html');
          ['#cart-drawer-form', '#MinimogCartDrawerFooter'].forEach(function (sel) {
            var cur = document.querySelector(sel), next = doc.querySelector(sel);
            if (!cur || !next) return;
            if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility.viewTransition) {
              HTMLUpdateUtility.viewTransition(cur, next);
            } else {
              cur.innerHTML = next.innerHTML;
            }
          });
        }
        if (payload['cart-template']) {
          var pdoc = new DOMParser().parseFromString(payload['cart-template'], 'text/html');
          ['#MinimogCartHeader', '#MinimogCartBody', '#MinimogCartFooter'].forEach(function (sel) {
            var cur = document.querySelector(sel), next = pdoc.querySelector(sel);
            if (!cur || !next) return;
            if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility.viewTransition) {
              HTMLUpdateUtility.viewTransition(cur, next);
            } else {
              cur.innerHTML = next.innerHTML;
            }
          });
        }
        if (payload['cart-count']) {
          var cdoc = new DOMParser().parseFromString(payload['cart-count'], 'text/html');
          var from = cdoc.querySelector('m-cart-count');
          if (from) document.querySelectorAll('m-cart-count').forEach(function (el) {
            el.className = from.className;
            el.textContent = from.textContent.trim();
          });
        }
      })
      .then(function () {
        // the swap above replaced the footer, taking every listener bound to it
        // with it — without this the warranty pills die after the first click
        addonsInit();
      })
      .catch(function () { /* nothing to do — the cart is right server-side */ });
  }

  function addBag() {
    var v = find(state.kind, state.color, state.size);
    if (!v) return finish(false);
    var btn = root.querySelector('[data-upm-add]');
    if (btn) btn.disabled = true;
    var props = {};
    props[tx('propColor', 'Barva')] = state.color;
    props[tx('propSize', 'Velikost')] = state.size;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return redrawDrawer(); })
      .catch(function () { /* fall through — the screen still closes */ })
      .finally(function () {
        if (btn) btn.disabled = false;
        finish(true);
      });
  }

  // ------------------------------------------------------------- safety net
  // The theme redraws the cart from the `sections` payload that rides along with
  // /cart/add.js and /cart/change.js. When that payload does not arrive — or its
  // handler throws — the markup silently keeps showing the state the page was
  // loaded with: an add looks like nothing happened and a remove needs a manual
  // refresh. Rather than guess why, compare what is drawn against the real cart
  // after every change and repair it only when the two disagree. Costs one small
  // request per change and does nothing at all while the theme is behaving.
  var resyncing = false;
  function resync() {
    if (resyncing) return;
    resyncing = true;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = cart.items.length;
        var drawn = [].slice.call(document.querySelectorAll('#cart-drawer-form [data-cart-item], #MinimogCartBody [data-cart-item]'))
          .filter(function (el) { return !el.closest('[style*="display: none"]'); }).length;
        var showsEmpty = !!document.querySelector('.m-cart-drawer__empty, .m-cart__empty');
        var stale = drawn !== lines || (lines > 0 && showsEmpty);
        log('resync: narisanih=' + drawn + ' v kosarici=' + lines + ' prazno=' + showsEmpty + ' -> ' + (stale ? 'POPRAVLJAM' : 'ok'));
        if (stale) return redrawDrawer();
      })
      .catch(function (e) { log('resync failed', e); })
      .finally(function () { resyncing = false; });
  }

  function watchCart() {
    if (!window.MinimogEvents || !window.MinimogTheme || !window.MinimogTheme.pubSubEvents) return false;
    // our own subscriber, so a throw inside the theme's one cannot stop it
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function (evt) {
      log('cartUpdate, sections:', evt && evt.cart && evt.cart.sections ? Object.keys(evt.cart.sections) : 'NI JIH');
      setTimeout(resync, 700);
    });
    return true;
  }
  if (!watchCart()) document.addEventListener('DOMContentLoaded', watchCart);

  // ---------------------------------------------------- product page extras
  // Volume cards drive the real quantity field, so the discount the card
  // promises is the one Shopify applies — nothing is faked in the price.
  function tierCards() {
    var box = document.querySelector('[data-upm-tiers]');
    if (!box || box.__upmInit) return;
    box.__upmInit = true;
    // The page carries a second buy form in the sticky bar, with its own quantity
    // field and the same id (a theme bug). On a phone that bar is what most
    // people actually tap, so the tier has to reach BOTH fields or the choice is
    // silently lost. The first one is used to read the current value back.
    function qtyFields() {
      return [].slice.call(document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"]'));
    }
    var qty = qtyFields()[0];
    box.addEventListener('click', function (e) {
      var card = e.target.closest('[data-qty]');
      if (!card) return;
      box.querySelectorAll('.upm-tier').forEach(function (c) { c.classList.toggle('is-active', c === card); });
      qtyFields().forEach(function (f) {
        f.value = card.dataset.qty;
        // the theme watches this field, so tell it the value moved
        f.dispatchEvent(new Event('change', { bubbles: true }));
      });
      paintBagCard();
    });
    // a customer who nudges the quantity by hand should see the matching card
    qtyFields().forEach(function (f) {
      f.addEventListener('change', function () {
        box.querySelectorAll('.upm-tier').forEach(function (c) {
          c.classList.toggle('is-active', c.dataset.qty === String(f.value));
        });
        paintBagCard();
      });
    });
  }

  // Ticking the bag on the product page is a decision already made — add it
  // straight after the watch and skip the upsell screen entirely.
  // ---- product-page bag card ------------------------------------------
  // The same controls as the cart screen, resolved against the same variant map,
  // so a customer who has already decided never gets asked twice.
  var bagCard = { kind: 'plain', color: null, size: null };   // one version of the bag

  // One bag holds up to three watches; a bigger order still gets the largest.
  function bagSizeForQty(q) {
    var want = q >= 3 ? 3 : (q >= 2 ? 2 : 1);
    var sizes = data ? uniq(data.variants.map(function (v) { return v.size; })) : [];
    for (var i = 0; i < sizes.length; i++) {
      if (new RegExp('\\b' + want + '\\b').test(sizes[i])) return sizes[i];
    }
    return sizes[0] || null;
  }

  function selectedQty() {
    var box = document.querySelector('[data-upm-tiers]');
    var act = box && box.querySelector('.upm-tier.is-active');
    return (act && Number(act.dataset.qty)) || 1;
  }

  function bagVariant() { return find(bagCard.kind, bagCard.color, bagCard.size); }

  function paintBagCard() {
    var card = document.querySelector('[data-upm-bagcard]');
    if (!card || !data) return;
    var q = selectedQty();
    bagCard.size = bagSizeForQty(q);
    var v = bagVariant();

    var price = card.querySelector('[data-upm-bagprice]');
    // the card adds the roll together with the watch, so the deal applies
    if (price) price.innerHTML = v ? priceHtml(v.price, true) : '—';
    var note = card.querySelector('[data-upm-bagnote]');
    if (note && dealPct() && !note.__upmDeal) {
      note.__upmDeal = true;
      note.textContent = tx('dealTag', '−%PCT% % ob nakupu ure').replace('%PCT%', dealPct()) + ' · ' + note.textContent;
    }

    var cap = card.querySelector('[data-upm-bagcap]');
    if (cap) {
      cap.textContent = capLine(bagCard.size, q);
    }
  }

  function bagCardInit() {
    var card = document.querySelector('[data-upm-bagcard]');
    if (!card || card.__upmInit || !data) return;
    card.__upmInit = true;

    var colors = uniq(data.variants.map(function (v) { return v.color; }));
    bagCard.color = colors[0];

    var cbox = card.querySelector('[data-upm-bagcolors]');
    if (cbox) {
      cbox.innerHTML = colors.map(function (c) {
        return '<button type="button" class="upm-swatch' + (c === bagCard.color ? ' is-active' : '') +
          '" data-color="' + c + '" title="' + c + '" aria-label="' + c +
          '" style="background:' + swatchHex(c) + '"></button>';
      }).join('');
      cbox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-color]');
        if (!b) return;
        bagCard.color = b.dataset.color;
        cbox.querySelectorAll('.upm-swatch').forEach(function (x) {
          x.classList.toggle('is-active', x.dataset.color === bagCard.color);
        });
        paintBagCard();
      });
    }

    var check = card.querySelector('[data-upm-addbag]');
    var opts = card.querySelector('[data-upm-bagopts]');
    if (check && opts) check.addEventListener('change', function () {
      opts.hidden = !check.checked;
      card.classList.toggle('is-on', check.checked);
    });

    paintBagCard();
  }

  function bagChecked() {
    var el = document.querySelector('[data-upm-addbag]');
    if (!el || !el.checked) return null;
    return bagVariant();
  }
  function addChosenBag(v) {
    var props = {};
    props[tx('propColor', 'Barva')] = bagCard.color;
    props[tx('propSize', 'Velikost')] = bagCard.size;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    }).then(function (r) { return r.json(); }).then(function () { return redrawDrawer(); })
      .catch(function () { /* the watch is in either way */ });
  }

  // ------------------------------------------------- cart opt-in checkboxes
  // Protection and the warranty are plain products, so a tick is an add and an
  // untick is a quantity-0 change. The markup is re-rendered by the theme after
  // every cart change, so the boxes cannot drift out of step with the cart.
  function cartLineFor(variantId) {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === String(variantId)) return i + 1;
        }
        return 0;
      });
  }
  function addLine(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
  }
  function removeLine(variantId) {
    return cartLineFor(variantId).then(function (line) {
      if (!line) return null;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: 0 })
      });
    });
  }

  // The travel roll as a cart opt-in, for whoever skipped the screen after the
  // watch. Liquid only prints the row when the cart holds a watch, which is
  // exactly when the admin discount applies, so the deal price shown is true.
  // The size follows the number of watches; only the colour is chosen here.
  // It reads the same variant map as the upsell, which every page carries.
  function rollInit(row, busy) {
    if (!data || !data.variants || !data.variants.length) { row.hidden = true; return; }
    var toggle = row.querySelector('[data-upm-roll-toggle]');
    var opts = row.querySelector('[data-upm-roll-opts]');
    var cbox = row.querySelector('[data-upm-roll-colors]');
    var priceEl = row.querySelector('[data-upm-roll-price]');
    var noteEl = row.querySelector('[data-upm-roll-note]');
    var colors = uniq(data.variants.map(function (v) { return v.color; }));
    var color = colors.indexOf(row.dataset.color) >= 0 ? row.dataset.color : colors[0];
    var size = bagSizeForQty(Number(row.dataset.watches) || 1);

    // another accessory already in the cart may take the one discounted slot
    var deal = dealPct() && !row.hasAttribute('data-nodeal');

    function variant() { return find('plain', color, size); }
    function paintRoll() {
      var v = variant();
      if (priceEl) priceEl.innerHTML = !v ? '—' : (deal ? priceHtml(v.price, true) : '+' + money(v.price));
      if (toggle) toggle.disabled = !v;
    }
    if (noteEl && deal) {
      noteEl.textContent = tx('dealTag', '−%PCT% % ob nakupu ure').replace('%PCT%', dealPct()) + ' · ' + noteEl.textContent;
    }
    if (cbox) {
      cbox.innerHTML = colors.map(function (c) {
        return '<button type="button" class="upm-swatch' + (c === color ? ' is-active' : '') +
          '" data-color="' + c + '" title="' + c + '" aria-label="' + c +
          '" style="background:' + swatchHex(c) + '"></button>';
      }).join('');
    }

    // every roll line in the cart, whatever its variant, so a colour change
    // replaces the roll rather than adding a second one
    function clearRoll() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ids = cart.items.filter(function (i) { return i.handle === row.dataset.handle; })
            .map(function (i) { return i.variant_id; });
          return ids.reduce(function (chain, id) {
            return chain.then(function () { return removeLine(id); });
          }, Promise.resolve());
        });
    }
    function addRoll() {
      var v = variant();
      if (!v) return Promise.resolve();
      var props = {};
      props[tx('propColor', 'Barva')] = color;
      props[tx('propSize', 'Velikost')] = size;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
      });
    }
    function run(job) {
      busy(true);
      job.then(redrawDrawer).catch(function () {}).finally(function () { busy(false); });
    }

    if (toggle) toggle.addEventListener('change', function () {
      if (addonBusy) return;
      if (opts) opts.hidden = !toggle.checked;
      row.classList.toggle('is-on', toggle.checked);
      run(toggle.checked ? clearRoll().then(addRoll) : clearRoll());
    });
    if (cbox) cbox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-color]');
      if (!b || addonBusy) return;
      color = b.dataset.color;
      cbox.querySelectorAll('.upm-swatch').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      paintRoll();
      if (toggle && toggle.checked) run(clearRoll().then(addRoll));
    });
    paintRoll();
  }

  var addonBusy = false;
  // Every add-ons box on the page (the drawer, and the cart page has its own).
  // The theme redraws the drawer footer on its own after an add, which drops
  // the box and its listeners — after adding a watch the ticks did nothing
  // until a reload. The observer in boot() calls this again whenever a fresh,
  // unbound box appears, so it never matters who drew it.
  function addonsInit() {
    document.querySelectorAll('[data-upm-adds]').forEach(function (box) {
      if (!box.__upmInit) addonsBox(box);
    });
  }
  function addonsBox(box) {
    box.__upmInit = true;
    box.classList.add('is-bound');   // what the observer looks for

    function busy(on) {
      addonBusy = on;
      box.classList.toggle('is-busy', on);
    }

    // shipping protection — one variant, straight on or off
    var prot = box.querySelector('[data-upm-add-toggle]');
    if (prot) prot.addEventListener('change', function () {
      if (addonBusy) return;
      busy(true);
      var job = prot.checked ? addLine(prot.dataset.variant) : removeLine(prot.dataset.variant);
      Promise.resolve(job).then(redrawDrawer).catch(function () {}).finally(function () { busy(false); });
    });

    var roll = box.querySelector('[data-upm-roll]');
    if (roll) rollInit(roll, busy);

    // warranty — the tick turns it on, the pills choose the length
    var warr = box.querySelector('[data-upm-warr]');
    if (!warr) return;
    var toggle = warr.querySelector('[data-upm-warr-toggle]');
    var opts = warr.querySelector('[data-upm-warr-opts]');
    var priceEl = warr.querySelector('[data-upm-warr-price]');

    function chosen() { return opts && opts.querySelector('.is-active'); }
    function allVariants() {
      return [].slice.call(opts ? opts.querySelectorAll('[data-warr-variant]') : [])
        .map(function (b) { return b.dataset.warrVariant; });
    }
    // only one length may sit in the cart at a time
    function clearAll() {
      return allVariants().reduce(function (chain, id) {
        return chain.then(function () { return removeLine(id); });
      }, Promise.resolve());
    }

    if (toggle) toggle.addEventListener('change', function () {
      if (addonBusy) return;
      busy(true);
      if (opts) opts.hidden = !toggle.checked;
      warr.classList.toggle('is-on', toggle.checked);
      var pick = chosen();
      var job = toggle.checked && pick ? clearAll().then(function () { return addLine(pick.dataset.warrVariant); }) : clearAll();
      job.then(redrawDrawer).catch(function () {}).finally(function () { busy(false); });
    });

    if (opts) opts.addEventListener('click', function (e) {
      var b = e.target.closest('[data-warr-variant]');
      if (!b || addonBusy) return;
      opts.querySelectorAll('[data-warr-variant]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      // Liquid prints variant.price in CENTS, so it goes to money() as it is
      if (priceEl) priceEl.textContent = '+' + money(Number(b.dataset.warrPrice));
      if (!toggle || !toggle.checked) return;
      busy(true);
      clearAll().then(function () { return addLine(b.dataset.warrVariant); })
        .then(redrawDrawer).catch(function () {}).finally(function () { busy(false); });
    });
  }

  // ------------------------------------------------------------------ hooks
  // Remember whether the add came from a ready-made watch. This flag only
  // decides whether the upsell appears; it can never hold anything up.
  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      pendingWatch = !!form.closest('[data-upm-watch]');
    } catch (err) { pendingWatch = false; }
  }, true);

  document.addEventListener('product-ajax:added', function (e) {
    if (!pendingWatch) return;
    pendingWatch = false;
    try {
      var chosen = bagChecked();
      if (chosen) { addChosenBag(chosen); return; }   // already chosen, no screen
      var d = e.detail && e.detail.product;
      if (d && d.items && d.items.length) d = d.items[0];
      show(d);
    } catch (err) {
      console.error('[upm] upsell failed, cart is unaffected:', err);
    }
  });

  // The Foxify sticky bar reveals itself as soon as the main buy button is not
  // fully in view, which on a phone means it covers the options while they are
  // still being read. Hold it until the customer has actually reached the
  // description, then leave it up for good. If any of this fails the bar simply
  // behaves as the app intended.
  function stickyAtcGate() {
    var bar = document.querySelector('.m-sticky-addtocart, .x-sticky-atc');
    if (!bar || !('IntersectionObserver' in window)) return;
    // Whatever comes after the buy column: this template has no description
    // block, the copy lives in the sections below, and which section that is
    // differs per product — so take the next one rather than name it.
    var main = document.querySelector("product-info[id^='MainProduct']") || document.querySelector('.m-main-product');
    var sect = main && main.closest('.shopify-section');
    var anchor = (sect && sect.nextElementSibling) || document.querySelector('.m-specs');
    if (!anchor) return;
    document.body.classList.add('upm-atc-hold');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        document.body.classList.remove('upm-atc-hold');
        io.disconnect();
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  // The cart drawer is redrawn the same way wherever something is added to the
  // cart, so the home page's cases section borrows this rather than carrying a
  // second copy of it. Nothing else here is public.
  window.UPM = window.UPM || {};
  window.UPM.redraw = redrawDrawer;

  // The personalizers add to the cart with their own fetch, not a theme form,
  // so the theme's add event never fires for them. They used to send the
  // customer straight to /cart — the one kind of watch that never saw the
  // case. They call this instead: the drawer is redrawn and opened as for any
  // other watch, and the upsell covers it. `item` is the line /cart/add.js
  // returned. Returns false when it cannot help, so the caller can still fall
  // back to /cart.
  window.UPM.offer = function (item) {
    // without a drawer there is nothing to land on once the upsell closes
    if (!document.querySelector('#cart-drawer-form')) return false;
    try {
      init();
      // the theme's open-cart-drawer event does nothing here; the element's
      // own open() does
      redrawDrawer().then(function () {
        var d = document.querySelector('m-cart-drawer');
        try { if (d && d.open) d.open(); } catch (err) { /* the upsell still shows */ }
      });
      show(item);
      return true;
    } catch (err) {
      console.error('[upm] offer failed:', err);
      return false;
    }
  };

  // The spare strap in Extras (snippets/upm-cfg-strap). The head opens a picture
  // of every option; picking one is what adds it, picking it again takes it back.
  // UPM.strap adds the picked one after the watch and resolves with the watch's
  // line either way, so a failed strap never costs the watch its drawer.
  function strapData(box) {
    if (!box.__cs) box.__cs = { d: JSON.parse(box.querySelector('[data-cs-data]').textContent), t: null, a: null, b: null };
    return box.__cs;
  }
  function strapDraw(box) {
    var s = strapData(box), grid = box.querySelector('[data-cs-grid]');
    grid.innerHTML = '';
    s.d.forEach(function (p, t) {
      var head = document.createElement('p'), tiles = document.createElement('div'), seen = {};
      head.className = 'upm-cs__label'; head.textContent = p.name + ' · ' + p.price;
      tiles.className = 'upm-cs__tiles';
      p.variants.forEach(function (v) {
        if (!v.ok || seen[v.a]) return;
        seen[v.a] = true;
        var b = document.createElement('button'), n = document.createElement('span');
        b.type = 'button';
        b.className = 'upm-cs__tile' + (s.t === t && s.a === v.a ? ' is-on' : '');
        b.setAttribute('data-cs-t', t); b.setAttribute('data-cs-a', v.a);
        b.setAttribute('aria-pressed', s.t === t && s.a === v.a ? 'true' : 'false');
        if (v.img) { var i = new Image(); i.src = v.img; i.alt = ''; b.appendChild(i); }
        n.textContent = v.a; b.appendChild(n);
        tiles.appendChild(b);
      });
      grid.appendChild(head); grid.appendChild(tiles);
    });
    var wrap = box.querySelector('[data-cs-clasp]'), chips = box.querySelector('[data-cs-b]');
    wrap.hidden = s.t === null;
    box.classList.toggle('is-picked', s.t !== null);
    box.querySelector('[data-cs-price]').textContent = s.t === null ? box.dataset.from : '+' + s.d[s.t].price;
    if (s.t === null) return;
    var bs = s.d[s.t].variants.filter(function (v) { return v.ok && v.a === s.a; }).map(function (v) { return v.b; });
    if (bs.indexOf(s.b) < 0) s.b = bs[0];
    chips.innerHTML = '';
    bs.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'upm-cs__chip' + (v === s.b ? ' is-on' : '');
      b.setAttribute('data-cs-pick-b', v); b.textContent = v;
      chips.appendChild(b);
    });
  }
  document.addEventListener('click', function (e) {
    var box = e.target.closest('[data-upm-strap]'); if (!box) return;
    var s = strapData(box), head = e.target.closest('[data-cs-toggle]'),
      tile = e.target.closest('[data-cs-t]'), chip = e.target.closest('[data-cs-pick-b]');
    if (head) {
      var panel = box.querySelector('[data-cs-panel]');
      panel.hidden = !panel.hidden;
      head.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      box.classList.toggle('is-open', !panel.hidden);
      if (panel.hidden) return;
    } else if (tile) {
      var t = +tile.getAttribute('data-cs-t'), a = tile.getAttribute('data-cs-a');
      if (s.t === t && s.a === a) { s.t = null; s.a = null; } else { s.t = t; s.a = a; }
    } else if (chip) {
      s.b = chip.getAttribute('data-cs-pick-b');
    } else return;
    strapDraw(box);
  });
  window.UPM.strap = function (root, item) {
    var box = root.querySelector('[data-upm-strap]');
    if (!item || !box || !box.__cs || box.__cs.t === null) return item;
    var s = box.__cs, v = s.d[s.t].variants.filter(function (x) { return x.a === s.a && x.b === s.b; })[0];
    if (!v) return item;
    var props = {}; props[box.dataset.for] = item.product_title;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] }) })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        s.t = null; s.a = null; strapDraw(box);
        return item;
      })
      .catch(function (err) { console.error('[upm] strap failed:', err); return item; });
  };

  function watchAddons() {
    if (!('MutationObserver' in window) || !document.body || document.body.__upmAddonsObs) return;
    document.body.__upmAddonsObs = true;
    new MutationObserver(function () {
      if (document.querySelector('[data-upm-adds]:not(.is-bound)')) addonsInit();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() { init(); tierCards(); bagCardInit(); stickyAtcGate(); addonsInit(); watchAddons(); }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
})();
